import gql from "graphql-tag";

export const ADD_WEATHER = gql`
  mutation addWeather($where: AddWeatherInput!) {
    addWeather(where: $where)
  }
`;